/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Unpin_TitleInputs */



/**
* | output |
* | --- |
* | "Unpin" |
*
* @param {Voice_Manager_Unpin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_title = /** @type {((inputs?: Voice_Manager_Unpin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Depingler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sbloccare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открепить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desprender")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消固定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピンを外す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनपिन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desafixar")
	return /** @type {LocalizedString} */ ("Unpin")
});